import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { PluginRevenuePage } from './PluginRevenuePage';

export const routes: FeatureRoute[] = [
  {
    path: 'foodpanda-revenue',
    element: (
      <RequireCapability anyOf={['subscriptions.manage']} what="Foodpanda revenue">
        <PluginRevenuePage plugin="foodpanda" />
      </RequireCapability>
    ),
  },
  {
    path: 'email-revenue',
    element: (
      <RequireCapability anyOf={['subscriptions.manage']} what="Email revenue">
        <PluginRevenuePage plugin="email" />
      </RequireCapability>
    ),
  },
];
